var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card-item p-3" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "v-app",
        [
          _c("v-data-table", {
            staticClass: "elevation-1",
            attrs: {
              headers: _vm.headers,
              items: _vm.endpointStatsList,
              "items-per-page": 100,
              search: _vm.search,
            },
            scopedSlots: _vm._u([
              {
                key: "top",
                fn: function () {
                  return [
                    _c("v-text-field", {
                      staticClass: "mx-4",
                      attrs: { label: "Arama" },
                      model: {
                        value: _vm.search,
                        callback: function ($$v) {
                          _vm.search = $$v
                        },
                        expression: "search",
                      },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "item.userId",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c("tr", { staticStyle: { width: "50px!important" } }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.getUserName(item.userId)) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "item.createDate",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c("tr", { staticStyle: { width: "50px!important" } }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("ddMMyyyyHHmm")(_vm.createDate)) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "section-block mb-4" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "d-flex align-items-center justify-content-between mb-3" },
      [_c("h3", { staticClass: "title" }, [_vm._v("Endpoint Stats")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }